module.exports = __webpack_public_path__ + "img/location-icon.41a782f8.svg";